export default "__VITE_ASSET__DCUOj5Op__"